import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import moment from "moment";
import { UserService } from "../../domain/user-service";
import { Logger } from "../../infrastructure/logger";
import { ExportPlatformsComponent } from "../export-platforms/export-platforms";
import { ExportConfiguration } from "../../domain/export-configuration";
import { HttpService } from "../../infrastructure/http/http";
import { UI } from "../../services/ui.service";
import { environment } from "app/environments/environment";

@Component({
  selector: "icn-clean-scheduler",
  templateUrl: "./clean-scheduler.html",
  styleUrls: ["./clean-scheduler.scss"],
})
export class CleanSchedulerComponent {
  constructor(
    private userService: UserService,
    private httpService: HttpService,
    private ui: UI,
  ) {}

  endpoint: string;
  channelTimezone: string;

  startDate: moment.Moment;

  endDate: moment.Moment;

  ngOnInit() {
    this.endpoint = environment.ENDPOINT + "/api/";
    this.userService.getCurrentChannel().then((channel) => {
      this.channelTimezone = this.userService.getTimezoneValueById(
        channel.timezoneId,
      );
    });
  }

  deletePlaylist() {
    if (this.startDate && this.endDate) {
      this.userService.getCurrentChannel().then((channel) => {
        const channelOffset = moment().tz(this.channelTimezone).utcOffset();
        const channelStartTime = this.startDate
          .clone()
          .subtract(channelOffset, "minutes");
        const channelEndTime = this.endDate
          .clone()
          .subtract(channelOffset, "minutes");
        this.httpService
          .post("Scheduler/CleanScheduler", {
            ChannelId: channel.id,
            StartDate: channelStartTime.format("YYYYMMDD"),
            StartTime: channelStartTime.format("HHmmssSSS"),
            EndDate: channelEndTime.format("YYYYMMDD"),
            EndTime: channelEndTime.format("HHmmssSSS"),
          })
          .then(() => {
            this.ui.notify(this.ui.EVENTS.ShowAlert, {
              title: "Clean Scheduler",
              message: "Done!",
            });
          })
          .catch((err) => {
            this.ui.notify(this.ui.EVENTS.ShowAlert, {
              title: "Clean Scheduler",
              message: "Clean scheduler failed",
            });
          });
      });
    }
  }

  changeStartDate(val) {
    this.startDate = val;
  }

  changeEndDate(val) {
    this.endDate = val;
  }
}
